import { Field, FormikProps } from 'formik';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '@mui/material';
import { Checkbox } from 'components/Checkbox';
import { useDispatch } from 'react-redux';

import sendEvent from 'utils/sendEvent';
import { formPart, TypeOfAction } from 'utils/consts';
import { registerClickEvent } from 'utils/events';
import { RootDispatch } from 'storage/store';

export type RegulationAcceptanceProps<T> = FormikProps<
  T & { conditionsAccepted: boolean }
>;

const sendCheckboxEvent = (labelName: string) => {
  sendEvent({
    labelText: `${TypeOfAction.checkbox}: ${labelName}`,
    secondDimension: TypeOfAction.checkbox,
    thirdDimension: `${formPart.second}`,
    ...registerClickEvent
  });
};

export const conditionsAcceptedName = 'conditionsAccepted';

const RegulationAcceptance = <T,>({
  ...props
}: RegulationAcceptanceProps<T>) => {
  const { t } = useTranslation();
  const { touched, errors } = props;
  const { modals } = useDispatch<RootDispatch>();
  const handleRegulationsModal = () => {
    modals.changeRegulationsVisibility();
    sendEvent({
      labelText: t('COMMON_REGULATIONS'),
      secondDimension: TypeOfAction.link,
      thirdDimension: `${formPart.second}`,
      ...registerClickEvent
    });
  };
  return (
    <>
      <Field
        data-best-id="regulations-acceptance-field"
        inputProps={{
          'data-best-id': 'regulations-acceptance-field-checkbox'
        }}
        as={Checkbox}
        name={conditionsAcceptedName}
        label={
          <Trans i18nKey="PAGE_REGISTER_SECOND_STEP_CONDITIONS_LABEL_PART1" />
        }
        labelText={`${t(
          'PAGE_REGISTER_SECOND_STEP_CONDITIONS_LABEL_PART1'
        )} ${t('PAGE_REGISTER_SECOND_STEP_CONDITIONS_LABEL_PART2')}`}
        addEvent={() =>
          sendCheckboxEvent(
            `${t('PAGE_REGISTER_SECOND_STEP_CONDITIONS_LABEL_PART1')} ${t(
              'PAGE_REGISTER_SECOND_STEP_CONDITIONS_LABEL_PART2'
            )}`
          )
        }
        errors={errors && errors.conditionsAccepted}
        touched={touched.conditionsAccepted}
      />{' '}
      <Link
        onClick={handleRegulationsModal}
        variant="body1"
        component="button"
        type="button"
        sx={{
          verticalAlign: 'middle',
          fontWeight: 700,
          cursor: 'pointer'
        }}
      >
        <Trans i18nKey="PAGE_REGISTER_SECOND_STEP_CONDITIONS_LABEL_PART2" />
      </Link>
      <span style={{ verticalAlign: 'middle' }}>.</span>{' '}
    </>
  );
};

export default RegulationAcceptance;
